import script from "./AllPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./AllPartners.vue?vue&type=script&setup=true&lang=js"

import "./AllPartners.vue?vue&type=style&index=0&id=07098536&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07098536"]])

export default __exports__